import React from 'react'
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Api_Config from '../code/api/ApiConfig';
import ApiCustomer from "../code/api/ApiCustomer";
import ButtonConfirm, { ButtonConfirmSize } from "./ButtonConfirm";
import CustomerChangeTracker from '../code/helpers/CustomerChangeTracker';
import Toaster from "./Toaster";
import CustomerDetail from "../code/models/CustomerDetail";

interface ICustomerSubscriptionLegacy {
    customerId: number;
    currentUser: AuthAdminUserModel;
}

export default function CustomerSubscriptionLegacy({ customerId, currentUser }: ICustomerSubscriptionLegacy) {
    const company = Api_Config.getSelectedCompany();
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [customerDetail, setCustomerDetail] = React.useState<CustomerDetail>();

    React.useEffect(() => {
        loadCustomer();
    }, []);
    
    function loadCustomer() {
        ApiCustomer.getCustomer(customerId).then((c) => {
            if (!!c) {
                setCustomerDetail(c);
            }
        });
    }

    function showSkippedToast() {
        setToastMessage("The customer now ON skip bidding.");
    }

    function showUnSkippedToast() {
        setToastMessage("The customer now OFF skip bidding.");
    }

    function showUnableToast() {
        setToastMessage("Unabe to update customer.");
    }

    function handleSkipConfirm(doSkip: boolean) {
        if (doSkip && customerDetail) {
            ApiCustomer.skipCustomer(customerDetail.customerId).then(result => {
                if (result) {
                    showSkippedToast();
                    customerDetail.skipBidding = true;
                    CustomerChangeTracker.trigger(customerDetail.customerId);
                } else {
                    showUnableToast();
                }
            });
        }
    }

    function handleUnSkipConfirm(doUnSkip: boolean) {
        if (doUnSkip && customerDetail) {
            ApiCustomer.unSkipCustomer(customerDetail.customerId).then(result => {
                if (result) {
                    showUnSkippedToast();
                } else {
                    showUnableToast();
                }
            });
        }
    }

    // Format the money
    const moneyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: company.currencyCode });

    return (
        <React.Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">&nbsp;</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Product:</div>
                    <div className="col-md-2">BidNav</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Monthly Charge:</div>
                    <div className="col-md-2">{moneyFormatter.format(customerDetail?.monthlyCharge || 0)}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Skip Charge:</div>
                    <div className="col-md-2">{moneyFormatter.format(customerDetail?.monthlySkipBiddingCharge || 0)}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Can Remove:</div>
                    <div className="col-md-2">No</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Can Skip:</div>
                    <div className="col-md-2">Yes</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Is On Skip:</div>
                    <div className="col-md-2">{customerDetail?.skipBidding ? "Yes" : "No"}</div>
                    <div className="col-md-2">
                        {!!customerDetail && !customerDetail.skipBidding &&
                            <ButtonConfirm enabled={!customerDetail.deactivated}
                                buttonText="Skip" confirmTitle="Skip" confirmMessage={`Place ${customerDetail.firstName} ${customerDetail.lastName} on skip bidding?`}
                                buttonSize={ButtonConfirmSize.Small} cssClass="btn-sm" onConfirm={handleSkipConfirm} />}
                        {!!customerDetail && customerDetail.skipBidding &&
                            <ButtonConfirm enabled={!!customerDetail && !customerDetail.deactivated} buttonText="Unskip" confirmTitle="Cancel Skip"
                                confirmMessage={`Cancel skip bidding for ${customerDetail.firstName} ${customerDetail.lastName}`} buttonSize={ButtonConfirmSize.Small}
                                cssClass="btn-sm" onConfirm={handleUnSkipConfirm} />}
                    </div>
                </div>
            </div>
            <Toaster title="Customer Subscription" subtitle={`${customerDetail?.firstName} ${customerDetail?.lastName}`} message={toastMessage} />
        </React.Fragment >
    )
}

